import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './allowed-companies.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AllowedCompaniesDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const allowedCompaniesEntity = useAppSelector(state => state.allowedCompanies.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="allowedCompaniesDetailsHeading">
          <Translate contentKey="fleetSenseApp.allowedCompanies.detail.title">AllowedCompanies</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{allowedCompaniesEntity.id}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.allowedCompanies.company">Company</Translate>
          </dt>
          <dd>{allowedCompaniesEntity.company ? allowedCompaniesEntity.company.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/allowed-companies" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/allowed-companies/${allowedCompaniesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AllowedCompaniesDetail;
